<template>
    <div id="memorial-detail">
        <Content class="content-wrap">
            <div class="name-wrap">
                <span class="name">{{briefInfo.deadName}}</span>
                <span>纪念馆</span>
            </div>
            <div class="tabs-wrap">
                <ul class="nav-tabs-list">
                    <li class="tab-item" @click="selectTab(index)" :class="{active:currentTabIndex==index}" v-for="(item,index) in tabs" :key="index">{{item.name}}</li>
                </ul>
                <ul class="tabs-content">
                    <li v-show="currentTabIndex==0"><portal :info = briefInfo @showMoreBrief="currentTabIndex=1"></portal></li>
                    <li v-show="currentTabIndex==1"><brief :info = briefInfo></brief></li>
                    <li v-show="currentTabIndex==2"><photoAlbum :memorialId="memorialId"></photoAlbum></li>
                    <li v-show="currentTabIndex==3"><grieve ref="grieve" v-if="memorialId" :memorialId="memorialId"></grieve></li>
                </ul>
            </div>
        </Content>
    </div>
</template>

<script>
    import portal from  './components/portal'
    import brief from  './components/brief'
    import grieve from  './components/grieve'
    import photoAlbum from './components/photoAlbum'
    import util from '../../utils/util'
    import api from '../../api/api'
    import {mapMutations,mapState} from 'vuex'
    var self;
    export default {
        name: 'memorialDetail',
        components: {
            portal,
            brief,
            grieve,
            photoAlbum
        },
        data(){
            return{
                currentTabIndex:0,
                tabs:[{
                    name:'纪念馆',
                    id:''
                },{
                    name:'生平简介',
                    id:''
                },{
                    name:'个人相册',
                    id:''
                },{
                    name:'祭文悼词',
                    id:''
                },],
                briefInfo:{},
                memorialId:''
            }
        },
        computed:{
            ...mapState(['currentMemorialId'])
        },
        created(){
            self = this;
        },
        activated(){
            self.setCurrentMemorialId(this.$route.params.id)
            this.memorialId = this.$route.params.id;
            this.currentTabIndex = 0
            // console.log('currentMemorialId---',self.currentMemorialId)
            self.getMemorialDetail()
        },
        methods:{
            ...mapMutations(['setCurrentMemorialId']),
            getMemorialDetail(){
                var self = this;
                api.getMemorialDetail({memorialId:this.memorialId}).then(res=>{
                    // console.log('getMemorialDetail;;',res)
                    self.briefInfo = res
                }).catch(error =>{
                    this.$Message.error('详情数据获取错误')
                })
            },
            selectTab(index){
                this.currentTabIndex = index;
                if(index==3){
                    this.$refs.grieve.getGrieveList(true)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    #memorial-detail{
        background-color: #fff;
    }
    .content-wrap{
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 40px;
        .name-wrap{
            font-size: 36px;
            color: #333;
            padding: 50px;
            text-align: center;
            font-family: cursive;
            .name{
                padding-right: 20px;
                display: inline-block;
            }
        }
    }
    .tabs-wrap{
        .nav-tabs-list{
            overflow: hidden;
            display: inline-block;
            .tab-item{
                float: left;
                width: 184px;
                height: 50px;
                line-height: 50px;
                font-size: 18px;
                border: 1px solid #ccc;
                &:hover{
                    background-color: #009de952;
                    color: #fff;
                    border-color: #009de952;
                    cursor: pointer;
                }
                &.active{
                    background-color: #009DE9;
                    color: #fff;
                    border-color: #009DE9;
                }
            }
        }
        .tabs-content{}
    }
</style>
